import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';
import CircleMediumIcon from 'mdi-material-ui/CircleMedium';
import React from 'react';

const ScheduleLegend = ({ itemSize = 4 }) => {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <ListSubheader>Color guide</ListSubheader>
      </Grid>
      <Grid item xs={itemSize}>
        <ListItem>
          <ListItemIcon>
            <CircleMediumIcon className={classes.draft} />
          </ListItemIcon>
          <ListItemText>Draft</ListItemText>
        </ListItem>
      </Grid>
      <Grid item xs={itemSize}>
        <ListItem>
          <ListItemIcon>
            <CircleMediumIcon className={classes.schedulerActionRequired} />
          </ListItemIcon>
          <ListItemText>Scheduler action required</ListItemText>
        </ListItem>
      </Grid>
      <Grid item xs={itemSize}>
        <ListItem>
          <ListItemIcon>
            <CircleMediumIcon className={classes.assigneeActionRequired} />
          </ListItemIcon>
          <ListItemText>Assignee action required</ListItemText>
        </ListItem>
      </Grid>
      <Grid item xs={itemSize}>
        <ListItem>
          <ListItemIcon>
            <CircleMediumIcon className={classes.noActionRequired} />
          </ListItemIcon>
          <ListItemText>No action required</ListItemText>
        </ListItem>
      </Grid>
      <Grid item xs={itemSize}>
        <ListItem>
          <ListItemIcon>
            <CircleMediumIcon className={classes.unavailable} />
          </ListItemIcon>
          <ListItemText>Unavailable</ListItemText>
        </ListItem>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  draft: {
    color: '#56ca85'
  },
  schedulerActionRequired: {
    color: 'goldenrod'
  },
  assigneeActionRequired: {
    color: '#cb6bb2'
  },
  noActionRequired: {
    color: '#1e90ff'
  },
  unavailable: {
    color: '#121212'
  }
}));

export default ScheduleLegend;